const ACTIVE_VALUE_DATA_ATTR = 'data-active-on-scroll-value';
const ELS = document.querySelectorAll(`[${ACTIVE_VALUE_DATA_ATTR}]`);

export const activateElOnScroll = () => {
  const windowHeight = window.innerHeight;
  const { scrollY } = window;

  ELS.forEach((el) => {
    const value = el.getAttribute(ACTIVE_VALUE_DATA_ATTR);

    let isActive;

    if (Number(value)) {
      const relativeScrollPosition = (scrollY / windowHeight) * 100;

      isActive = relativeScrollPosition > Number(value);
    } else {
      isActive = scrollY > document.querySelector(value)?.offsetTop;
    }

    el.setAttribute('data-active-on-scroll', isActive);
  });
};
